// Munições e armas de arremesso como no Tibia Global (Canary: items.xml + data/scripts/weapons/scripts).
// - Cada munição tem o seu projétil (shootType oficial).
// - Burst Arrow: explode em 3x3 no alvo (dano físico de 0 até o máximo da arma; quem tem black skull não usa).
// - Diamond Arrow: acerta em círculo 5x5 em volta do alvo (fórmula normal de distância).
// - Poison Arrow e Viper Star: dano físico (0 até o máximo) e envenenam o alvo.
// - Nas munições com script o golpe passa pela armadura, mas não pela defesa do escudo (BLOCKARMOR).
// - Se a flecha de área erra, ela cai num quadrado ao lado do alvo e explode ali.

/** projétil oficial (CONST_ANI) por item: munições, arremessáveis e wands/rods */
export const SHOOT_BY_ITEM: Record<number, number> = {
  756: 33, 757: 33, 758: 33, 759: 33, 760: 33, 761: 33, 762: 35, 763: 34, 774: 40, 1781: 10, 2992: 13, 3064: 39, 3066: 39, 3067: 37,
  3069: 11, 3070: 37, 3071: 4, 3072: 11, 3073: 5, 3074: 5, 3075: 4, 3277: 1, 3287: 8, 3298: 9, 3347: 17, 3446: 2, 3447: 3, 3448: 6,
  3449: 7, 3450: 14, 6528: 16, 7363: 24, 7364: 22, 7365: 23, 7366: 20, 7367: 18, 7368: 19, 7378: 21, 8082: 11, 8083: 37, 8084: 39,
  8092: 5, 8093: 4, 8094: 11, 12603: 5, 12732: 37, 12741: 5, 14251: 44, 14252: 45, 15792: 45, 15793: 49, 16096: 5, 16115: 4, 16117: 39,
  16118: 37, 16141: 48, 16142: 50, 16143: 51, 17110: 1, 17111: 5, 21157: 53, 21158: 53, 21347: 4, 21349: 37, 21470: 3, 22119: 7,
  22183: 39, 22765: 5, 22766: 5, 22870: 31, 25700: 5, 25735: 56, 25757: 57, 25758: 58, 25759: 59, 25760: 11, 27457: 5, 27458: 37,
  28716: 30, 28717: 5, 28825: 37, 28826: 37, 29425: 4, 30399: 5, 30400: 39, 34090: 32, 34091: 37, 34151: 37, 34152: 37, 35521: 37,
  35522: 39, 35901: 57, 35902: 58, 36668: 4, 36669: 4, 36674: 29, 36675: 29, 39162: 5, 39163: 37, 40535: 1, 43882: 5, 43883: 5,
  43885: 30, 43886: 30, 47372: 5, 47373: 29, 49528: 11, 49529: 30, 49882: 11, 49883: 11, 49884: 11, 49885: 30, 49886: 30, 49887: 30,
};

const SQUARE1X1 = [[1, 1, 1], [1, 3, 1], [1, 1, 1]];
const CIRCLE2X2 = [[0, 1, 1, 1, 0], [1, 1, 1, 1, 1], [1, 1, 3, 1, 1], [1, 1, 1, 1, 1], [0, 1, 1, 1, 0]];

export interface AmmoScript {
  /** área em volta do ponto de impacto (3 = centro) */
  area?: number[][];
  /** efeito em cada quadrado da área */
  effect?: number;
  /** fórmula: 'skill' = 0 até o máximo da arma (COMBAT_FORMULA_SKILL); 'weapon' = mínimo e máximo normais */
  formula: 'skill' | 'weapon';
  /** veneno (CONDITION_POISON, dano de terra): [quantidade de toques, intervalo ms, dano por toque]; começa depois do 1º intervalo */
  poison?: Array<[number, number, number]>;
  /** quem está de black skull não consegue usar */
  noBlackSkull?: boolean;
}
export const AMMO_SCRIPTS: Record<number, AmmoScript> = {
  3449: { area: SQUARE1X1, effect: 5, formula: 'skill', noBlackSkull: true },      // burst arrow (CONST_ME_EXPLOSIONAREA)
  22119: { area: SQUARE1X1, effect: 5, formula: 'skill', noBlackSkull: true },
  25757: { area: CIRCLE2X2, effect: 12, formula: 'weapon' },                         // diamond arrow (CONST_ME_ENERGYHIT)
  35901: { area: CIRCLE2X2, effect: 12, formula: 'weapon' },
  3448: { formula: 'skill', poison: [[4, 4000, 3], [9, 4000, 2], [20, 4000, 1]] },  // poison arrow
  7366: { formula: 'skill', poison: [[10, 4000, 2], [20, 4000, 1]] },               // viper star
};

/** quadrados da área centrada no ponto de impacto */
export function ammoTiles(area: number[][], cx: number, cy: number): Array<[number, number]> {
  const out: Array<[number, number]> = [];
  const h = Math.floor(area.length / 2), w = Math.floor((area[0]?.length ?? 1) / 2);
  area.forEach((row, y) => row.forEach((v, x) => { if (v) out.push([cx + x - w, cy + y - h]); }));
  return out;
}

/** toques do veneno no formato do dano contínuo dos monstros: [intervalo, dano] */
export function poisonTicks(list: Array<[number, number, number]>): Array<[number, number]> {
  const out: Array<[number, number]> = [];
  for (const [n, iv, dmg] of list) for (let i = 0; i < n; i++) out.push([iv, dmg]);
  return out;
}
